import React from 'react';
import { Link } from 'react-router-dom';
import styles from './BlogResources.module.css';

const BlogResources = () => {
  const resources = [
    {
      category: "Latest Blog Posts",
      items: [
        {
          title: "Understanding Zero Trust Architecture",
          description: "A comprehensive guide to implementing zero trust security model in modern organizations.",
          date: "January 2025",
          readTime: "10 min read"
        },
        {
          title: "The Rise of AI in Cybersecurity",
          description: "How artificial intelligence is transforming threat detection and response.",
          date: "December 2024",
          readTime: "8 min read"
        },
        {
          title: "Cloud Security Best Practices",
          description: "Essential security measures for protecting cloud-based infrastructure.",
          date: "November 2024",
          readTime: "12 min read"
        }
      ]
    },
    {
      category: "Security Tools & Guides",
      items: [
        {
          title: "Security Assessment Toolkit",
          description: "A collection of open-source tools for security testing and assessment.",
          type: "Tool Collection",
          access: "Free Download"
        },
        {
          title: "Incident Response Playbook",
          description: "Step-by-step guide for handling security incidents effectively.",
          type: "PDF Guide",
          access: "Free Download"
        },
        {
          title: "Security Awareness Training",
          description: "Educational materials for employee security awareness programs.",
          type: "Training Material",
          access: "Member Access"
        }
      ]
    },
    {
      category: "Research Publications",
      items: [
        {
          title: "IoT Security Framework",
          description: "A proposed framework for securing Internet of Things devices.",
          publication: "International Journal of Security",
          year: "2024"
        },
        {
          title: "Advanced Persistent Threats",
          description: "Analysis of modern APT techniques and countermeasures.",
          publication: "Cybersecurity Conference 2024",
          year: "2024"
        },
        {
          title: "Machine Learning in IDS",
          description: "Implementation of ML algorithms in Intrusion Detection Systems.",
          publication: "Security Research Quarterly",
          year: "2023"
        }
      ]
    }
  ];

  return (
    <div className={styles.container} id="blog-resources">
      <h1 className={styles.title}>Blog & Resources</h1>
      <p className={styles.intro}>
        Stay updated with the latest in cybersecurity through my blog posts, tools, and research publications.
        These resources are designed to help organizations and individuals enhance their security posture.
      </p>

      {resources.map((section, index) => (
        <div key={index} className={styles.section}>
          <h2 className={styles.sectionTitle}>{section.category}</h2>
          <div className={styles.resourceGrid}>
            {section.items.map((item, idx) => (
              <Link 
                key={idx} 
                to={item.date ? {
                  pathname: `/blog/${item.title.toLowerCase().replace(/ /g, '-')}`,
                  state: { title: item.title }
                } : '#'} 
                className={styles.resourceCard}
              >
                <h3>{item.title}</h3>
                <p className={styles.description}>{item.description}</p>
                <div className={styles.metadata}>
                  {item.date && <span>{item.date}</span>}
                  {item.readTime && <span>{item.readTime}</span>}
                  {item.type && <span>{item.type}</span>}
                  {item.access && <span>{item.access}</span>}
                  {item.publication && <span>{item.publication}</span>}
                  {item.year && <span>{item.year}</span>}
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}

      <div className={styles.subscribe}>
        <h2>Stay Updated</h2>
        <p>Subscribe to receive notifications about new blog posts and resources.</p>
        <button className={styles.subscribeButton}>Subscribe to Updates</button>
      </div>
    </div>
  );
};

export default BlogResources;
